import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JwtAuthTokenService } from 'angular-jwt-auth';
import { BehaviorSubject, filter, first } from 'rxjs';
import { InformationRequest } from 'src/domains/charts/model/information/information.request';
import { UserTypeService } from '../legal-user/user-type.service';
import { InformationModel } from 'src/domains/charts/model/information/information.model';
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DefaultDateService {
  private static date: BehaviorSubject<InformationModel.minMaxDates> = new BehaviorSubject(
    undefined,
  );

  static get date$() {
    return this.date.pipe(filter((data) => !!data));
  }
  isAuthenticated$ = JwtAuthTokenService.isAuthenticated$.pipe(
    untilDestroyed(this),
    filter((res) => !!res),
  );
  constructor() {
    this.getDate();
  }
  getDate() {
    this.isAuthenticated$.subscribe((res) => {
      if (res) {
        DefaultDateService.date.subscribe((date) => {
          if (!date) {
            new InformationRequest.ChartsDate()
              .setData({ profileType: UserTypeService.getUserType()?.value })
              .call()
              .pipe(first())
              .pipe(untilDestroyed(this))
              .subscribe((date) => {
                DefaultDateService.date.next({ date: date.response.data.date, min: date.response.data.min });
              });
          }
        });
      }
    });
  }
}
